import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import './mycss.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Apiconnect from "../services/Apiconnect.js";

const Resetpass = () => {
   const { login } = useContext(AuthContext);
   const [bgimg, setBgimg] = useState('');
   const [email, setEmail] = useState('');
   const [otp, setOtp] = useState('');
   const [password, setPassword] = useState('');
   const [passwordVisible, setPasswordVisible] = useState(false);
   const [isLoading, setIsLoading] = useState(false);

   const navigate = useNavigate();

   useEffect(() => {
      const randomImageUrl = getRandomImage();
      setBgimg(randomImageUrl);

      // Get email from localStorage
      const storedEmail = localStorage.getItem("reset_email");
      if (storedEmail) {
         setEmail(storedEmail);
      }
   }, []);

   const getRandomImage = () => {
      const randomNum = Math.floor(Math.random() * 9) + 1;
      return `admin_codebase/bgpic1.jpg`;
   };

   const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);

      const indata = {
         email: email,
         otp: otp,
         password: password
      };

      try {
         const response = await Apiconnect.postDataNoauth("auth/resetpass", indata);
         console.log(response.data);
         if (response.data.status === 1) {
            toast.success('Password Reset Successfully!');
            setTimeout(() => {
               localStorage.removeItem("reset_email");
               navigate("/login", { replace: true });
            }, 2000);
         } else {
            toast.error(response.data.message || "Reset failed");
         }
         setIsLoading(false);
      } catch (error) {
         toast.error("Something went wrong!");
         console.error(error);
      }
   };

   return (
      <div className="container-fluid p-0 vh-100">
         <div className="row g-0 vh-100">
            <div className="col-xl-7 example" style={{ backgroundImage: `url(${bgimg})` }}></div>

            <div className="col-xl-5 vh-100">
               <div className="auth-full-page-content p-md-5 p-4">
                  <div className="w-100 p-5">
                     <div className="text-center">
                        <img style={{ maxWidth: '50%', marginBottom: 30 }} src="admin_codebase/b-logo.png" />
                        <h2><b>Reset Password</b></h2>
                     </div>

                     <form onSubmit={handleSubmit}>
                        <div className="row">
                           <div className="col-md-12">
                              <div className="mb-3">
                                 <label className="form-label">Email Address *</label>
                                 <input type="email" className="form-control inp" value={email} readOnly />
                              </div>
                           </div>

                           <div className="col-md-12">
                              <div className="mb-3">
                                 <label className="form-label">OTP *</label>
                                 <input
                                    type="number"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    className="form-control inp"
                                    placeholder="Enter OTP"
                                    required
                                 />
                              </div>
                           </div>

                           <div className="col-md-12">
                              <div className="mb-3">
                                 <label className="form-label">New Password *</label>
                                 <div className="input-group">
                                    <input
                                       type={passwordVisible ? "text" : "password"}
                                       value={password}
                                       onChange={(e) => setPassword(e.target.value)}
                                       className="form-control inp"
                                       placeholder="Enter new password"
                                       required
                                    />
                                    <button
                                       type="button"
                                       className="btn btn-outline-secondary"
                                       onClick={togglePasswordVisibility}
                                    >
                                       {passwordVisible ? "Hide" : "Show"}
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className="form-outline mb-4">
                           <input
                              type="submit"
                              className="form-control form-control-lg btn btn-primary submit"
                              value={isLoading ? "Please wait..." : "Reset Password"}
                              disabled={isLoading}
                           />
                        </div>
                     </form>

                     Back to <a href="/">Login</a>
                  </div>
               </div>
            </div>
         </div>

         <ToastContainer />
      </div>
   );
};

export default Resetpass;
